define('modules/profiles/main/views/profile.view',[
    'client',
    'jquery',
    'jqueryUi',
    'underscore',
    'backbone',
    "marionette",
    'modules/base/views/model.view',
    'modules/base/models/user.setting.model',
    'modules/base/models/identity.model',
    'modules/lists/models/follow.list.model',
    "modules/base/models/uniquify.companies.model",
    "modules/profiles/main/views/board.view",
    'modules/base/views/base.metric.view',
    'modules/base/views/subscription.button.view',
    'modules/profiles/main/views/profile.nav.view',
    'text!modules/profiles/main/templates/main.template.html'
], function(Prospector,$, jqueryUi, _,Backbone,
            Marionette,
            BaseView,
            UserSettingModel,
            IdentityModel,
            FollowingListModel,
            UniquifyCompaniesModel,
            BoardView,
            BaseMetricView,
            UpgradeTrialView,
            ProfileNav,
            Template) {
    var ProfileView = BaseView.extend({
        template: _.template(Template),
        className: 'profile bgWhite',
        modelSelector: 'boards',
        loader: 'ripple',
        loaderHtml:'<div class="profileload ripple_white_xl"><div></div><div></div></div>',
        isFirstLoad: true,
        index: -1,
        state: null,
        request: undefined,
        drawer: undefined,
        attempts: 0,
        mEvents:function() {
            var base = {
            };
            var click = {
                'click .editList': 'editList',
                'click .list': 'setIndex',
                'click .pageTitleBox, .editContactSub, .salesforceDrawer': 'menuPopup'
            };
            $.extend(base,click);
            return base;
        },
        initialize: function(options){
            Prospector.off('refreshBookmarks');
            this.showLoader(); // when profile is init show loader until board view loads
            this.identityType = options.identityType;
            this.sourceId = options.sourceId;
            this.refId = options.refId;
            this.request = options.request;
            this.drawer = options.drawer;
            //this.listenTo(Prospector, "menuClicked", this.setIndex, this);
            //this.listenToOnce(Prospector, 'triggerAutoFollow', this.followRequest, this);
            Prospector.on("refreshEditContact", this.editList, this);
            this.listenToOnce(Prospector, 'triggerAutoResearch', this.researchRequest, this);
            this.listenTo(Prospector, 'profileReceiveChild', this.receiveChild, this);
            BaseView.prototype.initialize.call(this, options);
        },
        buildModel:function(){
            var that = this;
            require(['modules/base/models/identity.profile.model'], function(IdentityProfileModel){
                if(window.location.href.indexOf("searchId=") > -1){
                    var searchId = window.utils.getQueryStringParameter(window.location.href.split("?")[1], "searchId");
                }
                that.model = new IdentityProfileModel({
                    identityType: that.identityType,
                    source:{
                        sourceId: that.sourceId,
                        refId: that.refId
                    },
                    searchId: searchId
                });
                that.fetchModel();
            });
        },
        fetchModel:function(){
            this.cleanMySubviews();
            this.$(this.modelSelector).empty();
            this.$(this.modelSelector).addClass('loader');
            this.listenToOnce(this.model, 'sync', this.procModel, this);
            if(this.abortable){
                if(this.currXHR != undefined && this.currXHR.readyState > 0 && this.currXHR.readyState < 4){
                    this.currXHR.abort();
                }
            }
            this.currXHR = this.model.fetch();
        },
        onRender: function() {
            if(Prospector.SettingsApp.hasSalesForce()){
                this.$(".salesforce").show();
            }
        },
        showLoader: function(){
            if(!$('.profileload').hasClass('ripple_white_xl')){
                $('.searchViewHolder').hide();
                $('.secondRow').append(this.loaderHtml);
            }
        },
        hideLoader:function(){
            $('.profileload').remove();
            $('.searchViewHolder').show();
        },
        procResponse:function(){
            this.$('.headerRow').show();
            this.$('.boards').append('<div class="boardColumn col1 col-sm-12 col-md-12"></div>');

            var profileNav = new ProfileNav({model: this.model}); // Profile Navigation
            $('nav').html(profileNav.render().el); // Render Profile Navigation
            this.addFollowingMenuBtn(); // Add "follow" menu item.

            window.currentProfile = this.model;
            document.getElementsByTagName('title')[0].innerHTML = this.model.getName() + ' - Profile - RelPro &reg;';
            this.$('.name').html(this.model.getName());
            this.receiveChild();
            var that = this;
            require(['modules/profiles/main/views/profile.submenu.view'],
                function(ProfileSubMenuView, ProfileFollowingView){
                    that.subMenu = new ProfileSubMenuView({parent: that});
                    // Prospector.trigger('fillSubMenu', {view: that.subMenu, passedFunc: $.proxy(that.buildRow, that, 'Profile loads', 'identityProfileLoads')} );
            });
        },
        buildListModel:function(){
            var dataSourceType = "";
            var refId = "";

            dataSourceType = this.model.get('source').sourceId;
            refId = this.model.get('source').refId;

            var model = {};

            var headline = "";
            if(this.identityType == "person"){
                headline = this.model.get('role');
                if(this.model.get('company') != ""){
                    if(headline != ""){
                        headline += " - " + this.model.get('company');
                    } else{
                        headline = this.model.get('company');
                    }
                }
                var firstName = this.model.get("firstName");
                if(firstName.length < 2 && this.model.get("middleName") != ""){
                    firstName += " " + this.model.get("middleName");
                }
                model = {
                    "firstName": firstName,
                    "lastName": this.model.get('lastName'),
                    "headline": headline,
                    "identityType": "person",
                    "contactType": "lead",
                    "isSharedContact": false,
                    "source": {
                        "refId": refId,
                        "sourceId": parseInt(dataSourceType)
                    }
                };
            }
            else {

                var headline = "";
                if (this.model.get('city') != undefined && this.model.get('city') != "") {
                    headline += this.model.get('city');
                }
                if (this.model.get('state') != undefined && this.model.get('state') != "") {
                    headline += ", " + this.model.get('state');
                }
                if (this.model.get('country') != undefined && this.model.get('country') != "") {
                    headline += " " + this.model.get('country');
                }
                if (headline == "") {
                    headline += this.model.get('headline');
                }

                model = {
                    "name": this.model.get('name'),
                    "headline": headline,
                    "identityType": "organization",
                    "contactType": "lead",
                    "isSharedContact": false,
                    "source": {
                        "refId": refId,
                        "sourceId": parseInt(dataSourceType)
                    }
                };
            }
            return model;
        },
        buildRow:function(quotaName,type) {
            var view = new BaseMetricView({
                title: quotaName,
                model: window.contractQuotas.get('quotas')[type]
            });
            if (window.contract.isTrial() || (view.getPercentUsed() >= Prospector.SettingsApp.hasCertainPercentage() && !window.contract.isTrial())) {
                $('.profileSubMenu').after('<div class="profileTrialSubMenu"></div>');
                $('.profileTrialSubMenu').append(view.render().el);
                if(window.contract.isTrial() && window.user.get('isAdmin')){
                    var btnView = new UpgradeTrialView({model: this.model});
                    $('.profileTrialSubMenu').addClass('hasSubBtn').append(btnView.render().el);
                }
            }
        },
        receiveChild:function(e){
            this.showLoader(); // when profile is init show loader until board view loads
            var interval = 550;
            if(this.model != undefined && this.model.get('boards') != undefined && this.index < this.model.get('boards').length - 4){
                this.index++;
                var board = this.model.get('boards')[this.index];
                var bv = new BoardView({model: board, parent: this});
                if(bv.model.get("name") == "Key Facts"){
                    if(this.model.get("firstName")){
                        var name = this.model.get("firstName") + ' ' + this.model.get("lastName");
                    } else if(this.model.get("name")){
                        var name = this.model.get("name");
                    }
                    this.$('.pageTitle').html(name + ' ' + board.name);
                    this.$('.boardColumn.col1'/*+ board.positionX*/).append(bv.render().el);
                    this.addFollowAndProfileBtn(); // Add "follow" menu btn whenever a new board is chosen for the current profile
                }

                this.subviews.push(bv);
            } else {
                if(this.model != undefined){
                    if(this.isFirstLoad){
                        this.isFirstLoad = false;
                    }
                    if(this.model.get('identityType') == "person"){
                        this.autoRunSetting = new UserSettingModel(window.user.get('userSettings')[0].userSettingsLevel1[2]);
                    } else {
                        this.autoRunSetting = new UserSettingModel(window.user.get('userSettings')[0].userSettingsLevel1[6]);
                    }
                }
            }
        },
        selectedBoard: function(e){
            var eVal = e.target.value + 1;
            if(this.model.get('boards').length <= 4){ // D&B company board has 4 or less boards. missing tech
                if(e.target.value > 1){
                    eVal = e.target.value;
                } else{
                    eVal = e.target.value + 1;
                }
            }
            var board = this.model.get('boards')[eVal];
            var bv = new BoardView({model: board, parent: this});
            if(this.model.get("firstName")){
                var name = this.model.get("firstName") + ' ' + this.model.get("lastName");
            } else if(this.model.get("name")){
                var name = this.model.get("name");
            }
            this.$('.pageTitle').html(name + ' ' + board.name);
            this.$('.boardColumn.col1').html(bv.render().el);
            this.addFollowAndProfileBtn(); // Add "follow" menu btn whenever a new board is chosen for the current profile
        },
        researchRequest:function () {
            if(typeof this.subMenu !== 'undefined' && this.subMenu != null){
                this.subMenu.feedSilentOpen();
            }
        },
        hasRequest:function(){
            var request = this.request;
            return request != null;
        },
        buildFollowRequest:function(){
            if(Prospector.SettingsApp.hasFollowing()){

                var identityType = this.model.get('identityType');
                var waitTime = 0;
                if(identityType == "person"){
                    waitTime = window.entitlements.get('settings').personAutoFollowTime;
                } else {
                    waitTime = window.entitlements.get('settings').orgAutoFollowTime;
                }
                if(waitTime > 0){
                    if(window.user.get('summary').totalFollowing == undefined){
                        if(this.attempts < 2){
                            this.attempts++;
                            var func = $.proxy(this.buildFollowRequest, this);
                            window.setTimeout(func, 2000, this);
                        }
                    } else {
                        if( window.user.get('summary').totalFollowing < window.entitlements.get('settings').followingLimit || window.entitlements.get('settings').followingLimit == 0) {
                            var followingValue = 0;
                            var profileSettings = window.user.get('userSettings')[0].userSettingsLevel1;
                            identityType = this.model.get('identityType');
                            if(identityType == 'person'){
                                followingValue = parseInt(profileSettings[3].value); //Enable Person Auto Following
                            } else {
                                followingValue = parseInt(profileSettings[7].value); //Enable Organization Auto Following
                            }
                            if(followingValue == 1){
                                /*window.setTimeout(function(){
                                    Prospector.trigger('triggerAutoFollow');
                                }, waitTime*1000);*/

                            }
                        } else {
                        }
                            //No More Follows
                    }
                } else {
                    //Auto follow is disabled for this identity type.
                }
            }

        },
        followRequest:function(){
            var identityType = this.model.get('identityType');
            var showFollowingValue = 0;
            var profileSettings = window.user.get('userSettings')[0].userSettingsLevel1;
            if(identityType == 'person'){
                showFollowingValue = parseInt(profileSettings[5].value); //Show Prompt before Person Auto Following
            } else {
                showFollowingValue = parseInt(profileSettings[9].value); //Show Prompt before Organization Auto Following
            }
            var cb = undefined;
            if(showFollowingValue == 1){
                cb = $.proxy(function(){
                    if(this.followingModel.isValid()) {
                        Prospector.trigger('showFollowingConfirm', {parent: this});
                    }
                }, this);
            } else {
            }
            this.procFollowRequest({passedFunc: cb});

        },
        procFollowRequest:function(options){
            var following = true;
            if(options != undefined && options.following != undefined){
                following = options.following;
            }
            if(following){
                this.followingModel = new FollowingListModel({
                    listId: 0,
                    identityId: this.model.get('id'),
                    alertType: 1
                });
                this.listenToOnce(this.followingModel, 'sync', this.procUpdateFollow, this);
                if(options != undefined && options.passedFunc != undefined){
                    this.listenToOnce(this.followingModel, 'sync', options.passedFunc);
                }
                this.followingModel.save();
            } else {
                this.followingModel = new FollowingListModel({
                    id: 1,
                    listId: 0,
                    identityId: this.model.get('id'),
                    alertType: 1
                });
                this.followingModel.mode = "delete";
                this.listenToOnce(this.followingModel, 'sync', this.procStopFollow, this);
                if(options != undefined && options.passedFunc != undefined){
                    this.listenToOnce(this.followingModel, 'sync', options.passedFunc);
                }
                this.followingModel.destroy();
            }
        },
        procUpdateFollow:function(){
            if(this.followingModel.isValid()){
                this.model.set({following: true});
                this.subMenu.updateFollowing();
                Prospector.trigger('refreshFollowing');
            } else {
                this.errOut(this.model.errorMessage);
            }
        },
        procStopFollow:function(){
            if(this.followingModel.isValid()){
                this.model.set({following: false});
                this.listenToOnce(window.user.following, 'sync', this.fixSubMenu, this);
                Prospector.trigger('refreshFollowing');
            } else {
                this.errOut(this.model.errorMessage);
            }
        },
        fixSubMenu:function(){
            this.subMenu.updateFollowing();
        },
        setIndex: function(e){
            if(e.target.value < 4){ // if menu item clicked is not "Follow" then set index in receiveChild()
                this.selectedBoard(e);
                this.$('.popMenu').hide();
                this.$('.popMenu2').hide();
            }
            if(e.target.value == 4){ // if Linkedin is clicked
                this.procLinkedIn();
                this.$('.popMenu').hide();
            }

            if(e.target.value == 7){ // if Linkedin is clicked
                this.editList();
                this.$('.popMenu').hide();
                this.$('.popMenu2').hide();
            }
            if(e.target.value == 6){ // if Salesforce is clicked
                this.showLoader();
                this.$('.popMenu').hide();
                this.salesForce();
            }
        },
        editList:function(){
            var that = this;
            require(["modules/profiles/subviews/views/edit.contact.sub.view"],
                function(EditContactSubView){
                    var mECSV = new EditContactSubView({parent: that, model: that.model});
                    $('.boardColumn').html(mECSV.render().el);
                    if(that.model.get("firstName")){
                        var name = that.model.get("firstName") + ' ' + that.model.get("lastName");
                    } else if(that.model.get("name")){
                        var name = that.model.get("name");
                    }
                    that.$('.pageTitle').html(name);
                });
        },
        salesForce:function(){
            var that = this;
            require(["modules/profiles/subviews/views/profile.salesforce.drawer"],
                function(ProfileSalesforceDrawer){
                    var mECSV = new ProfileSalesforceDrawer({parent: that});
                    $('.boardColumn').html(mECSV.render().el);
            });
        },
        procLinkedIn:function(){
            window.utils.identity.procLinkedIn(this.model);
        },

        menuPopup: function(){
            if(window.location.href.indexOf("person") > -1){ // If current profile page is of a person
                if ($('.popMenu').is(":visible")) {
                    $('.popMenu').toggle('slide');
                }
            }

            if(window.location.href.indexOf("organization") > -1){// If current profile page is of a Organization
                if ($('.popMenu2').is(":visible")) {
                    $('.popMenu2').toggle('slide');
                }
            }
        },
        addFollowAndProfileBtn: function(){
            var that = this;
            require(["modules/profiles/subviews/views/profile.following.btn.view"],
                function(ProfileFollowingView){
                    var fv = new ProfileFollowingView({model: that.model, check: true, parent: that});
                    that.$('.profile_buttons > .row.buttons').append(fv.render().el);
                    if(window.utils.isChromeExt()){
                        that.addOpenProfileBtn();
                    }
            });
        },
        addOpenProfileBtn: function(){
            var that = this;
            require(["modules/profiles/subviews/views/profile.open.full.view"],
                function(ProfileOpenFullView){
                    var fv = new ProfileOpenFullView({model: that.model, parent: that});
                    that.$('.profile_buttons > .row.buttons').append(fv.render().el);
            });
        },
        addFollowingMenuBtn: function(){
            var that = this;
            require(["modules/profiles/subviews/views/profile.following.menu.view"],
                function(ProfileFollowingMenuView){
                    var fv = new ProfileFollowingMenuView({model: that.model, check: true, parent: that});
                    if(window.location.href.indexOf("person") > -1){ // If current profile page is of a person
                        that.$('.popMenu > ul').append(fv.render().el);
                    }
                    if(window.location.href.indexOf("organization") > -1){ // If current profile page is of a Organization
                        that.$('.popMenu2 > ul').append(fv.render().el);
                    }

                    that.addOpenProfileMenuBtn();
            });
        },
        addOpenProfileMenuBtn: function(){
            if(window.utils.isChromeExt()){
                var that = this;
                require(["modules/profiles/subviews/views/profile.open.menu.view"],
                    function(ProfileOpenMenuView){
                        var fv = new ProfileOpenMenuView({model: that.model, parent: that});
                        if(window.location.href.indexOf("person") > -1){ // If current profile page is of a person
                            that.$('.popMenu > ul').append(fv.render().el);
                        }
                        if(window.location.href.indexOf("organization") > -1){ // If current profile page is of a Organization
                            that.$('.popMenu2 > ul').append(fv.render().el);
                        }
                });
            }
        }
    });
    return ProfileView;
});
